import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../consts/url';
import { ProjectContactModel } from '../store/models/project-contact.model';

@Injectable({ providedIn: 'root' })
export class ProjectContactService {
  constructor(private readonly http: HttpClient) {
  }

  public findAll(projectId: string): Observable<ProjectContactModel.Document[]> {
    return this.http.get<ProjectContactModel.Document[]>(
      api.projectContact.byProject(projectId),
    );
  }

  public create(
    projectId: string,
    payload: ProjectContactModel.API.CreateContactDto,
  ): Observable<ProjectContactModel.Document> {
    return this.http.post<ProjectContactModel.Document>(
      api.projectContact.byProject(projectId),
      payload,
    );
  }

  public bulkCreate(
    projectId: string,
    contacts: ProjectContactModel.API.BulkCreateContactDto,
  ): Observable<ProjectContactModel.Document[]> {
    return this.http.post<ProjectContactModel.Document[]>(
      api.projectContact.byProjectBulk(projectId),
      { contacts },
    );
  }

  public update(
    contactId: string,
    payload: ProjectContactModel.API.UpdateContactDto,
  ): Observable<ProjectContactModel.Document> {
    return this.http.put<ProjectContactModel.Document>(
      api.projectContact.byId(contactId),
      payload,
    );
  }

  public remove(contactId: string): Observable<ProjectContactModel.Document> {
    return this.http.delete<ProjectContactModel.Document>(
      api.projectContact.byId(contactId),
    );
  }
}
